// extracted by mini-css-extract-plugin
module.exports = {"container":"NumberWithButtons_container__2QJtN","input":"NumberWithButtons_input__ZqXS0","icon":"NumberWithButtons_icon__2B2VM"};